import * as request from "@/utils/request";

export default {
  getPersonalDeclareList(data) {
    return request.post("/qxy_declare_tax/channel_company_list", data);
  },
  declareSubmit(data) {
    return request.post("/qxy_declare_tax/declare_submit", data);
  },
  declareCancel(data) {
    return request.post("/qxy_declare_tax/declare_cancel", data);
  },
  declareUpdate(data) {
    return request.post("/qxy_declare_tax/declare_update", data);
  },
  declarePay(data) {
    return request.post("/qxy/pay_tax/getUrl", data);
  },
  //开户-查询地区列表
	get_qxy_tax_get_area(data) {
		return request.post('/qxy_tax/get_area', data)
	},
	//开户-查询账号信息
	get_qxy_tax_get_account_info(data) {
		return request.post('/qxy_tax/get_account_info', data)
	},
	//开户-订购+注册(原型中的"下一步")
	get_qxy_tax_register(data) {
		return request.post('/qxy_tax/register', data)
	},
	//开户-检验密码
	get_qxy_tax_check_password(data) {
		return request.post('/qxy_tax/check_password', data)
	},
	//获取个税缴纳链接地址
	get_qxy_pay_tax_getUrl(data) {
		return request.post('/qxy/pay_tax/getUrl', data)
	},
	//服务商列表
	get_qxy_declare_channel_list(data) {
		return request.post('/qxy_declare_tax/channel_list', data)
	},
	get_qxy_declare_tax_declare_view(data){
		return request.post('/qxy_declare_tax/declare_view', data)
	},

	// 导出申报人员收入记录
	getDeclareExport(data){
		return request.post('/declare/export', data)
	},
	// 导出申报信息记录
	getDeclareEmployeeExport(data){
		return request.get('/declareemployee/export', data)
	}
};
